import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"popsicle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20.3388 12.1469C22.6819 9.80379 22.6819 6.0048 20.3388 3.66166C17.9957 1.31851 14.1967 1.31851 11.8535 3.66166C11.8535 3.66166 12.2071 7.13642 16.0962 7.9043C19.9852 8.67217 20.3388 12.1469 20.3388 12.1469Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M2.66098 18.5102C1.87993 19.2912 1.87993 20.5576 2.66098 21.3386C3.44203 22.1197 4.70836 22.1197 5.48941 21.3386L9.3785 17.4495L6.55007 14.6211L2.66098 18.5102Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2.66098 18.5102C1.87993 19.2912 1.87993 20.5576 2.66098 21.3386C3.44203 22.1197 4.70836 22.1197 5.48941 21.3386L9.3785 17.4495L6.55007 14.6211L2.66098 18.5102Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20.3388 12.1469C22.6819 9.80379 22.6819 6.0048 20.3388 3.66166C17.9957 1.31851 14.1967 1.31851 11.8535 3.66166M20.3388 12.1469C20.3388 12.1469 19.9852 8.67217 16.0962 7.9043C12.2071 7.13642 11.8535 3.66166 11.8535 3.66166M20.3388 12.1469L12.207 20.2787L3.72168 11.7934L11.8535 3.66166","strokeWidth":"props.strokeWidth"}}]}]};

const Popsicle = Vue.extend<IconProps>({
  name: 'PopsicleIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'popsicle',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Popsicle;
